var _rect, _rect2, _rect3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 20,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#6092DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 13,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#6092DB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 27,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#6092DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 8H31.5C33.7091 8 35.5 9.79086 35.5 12V21C36.1801 21 36.8481 21.0522 37.5 21.1529V12C37.5 8.68629 34.8137 6 31.5 6H12.5C9.18629 6 6.5 8.68629 6.5 12V31C6.5 34.3137 9.18629 37 12.5 37H22.8479C22.6945 36.3508 22.5898 35.6828 22.5379 35H12.5C10.2909 35 8.5 33.2091 8.5 31V12C8.5 9.79086 10.2909 8 12.5 8Z",
    fill: "#6092DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.128 33C34.0534 32.9893 33.9573 32.9893 33.872 33C31.9939 32.9359 30.5 31.3969 30.5 29.5053C30.5 27.571 32.0579 26 34 26C35.9314 26 37.5 27.571 37.5 29.5053C37.4893 31.3969 36.0061 32.9359 34.128 33Z",
    stroke: "#6092DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 38.6055C39.5193 40.0952 36.8932 41 34 41C31.1068 41 28.4807 40.0952 26.5 38.6055C26.6113 37.7464 27.2789 36.9056 28.4696 36.2475C31.5185 34.5842 36.5037 34.5842 39.5304 36.2475C40.7211 36.9056 41.3887 37.7464 41.5 38.6055Z",
    stroke: "#6092DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDesk);
export default __webpack_public_path__ + "static/media/service-desk.fb740841.svg";
export { ForwardRef as ReactComponent };